export default "__VITE_ASSET__l$ntmxr3__"